import React from 'react';
import { MediaSource, Mode, Platform, Tone } from '../types';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

// --- Small modular subcomponents to simplify the main panel ---
const PlatformSelect: React.FC<{
  label: string;
  value: Platform;
  onChange: React.Dispatch<React.SetStateAction<Platform>>;
  enableEmailOption?: boolean;
  disableNonEmail?: boolean;
}> = ({ label, value, onChange, enableEmailOption, disableNonEmail }) => (
  <FormControl size="small" fullWidth>
    <InputLabel>{label}</InputLabel>
    <Select
      label={label}
      value={value}
      onChange={e => onChange(e.target.value as Platform)}>
      {enableEmailOption && <MenuItem value="email">Email</MenuItem>}
      {!disableNonEmail && (
        <>
          <MenuItem value="whatsapp">WhatsApp</MenuItem>
          <MenuItem value="instagram">Instagram</MenuItem>
          <MenuItem value="tiktok">TikTok</MenuItem>
          <MenuItem value="x">X (Twitter)</MenuItem>
          <MenuItem value="linkedin">LinkedIn</MenuItem>
          <MenuItem value="facebook">Facebook</MenuItem>
        </>
      )}
    </Select>
  </FormControl>
);

const ModeSelect: React.FC<{
  label: string;
  value: Mode;
  onChange: React.Dispatch<React.SetStateAction<Mode>>;
  urlLabel: string;
  textLabel: string;
}> = ({ label, value, onChange, urlLabel, textLabel }) => (
  <FormControl size="small" fullWidth>
    <InputLabel>{label}</InputLabel>
    <Select
      label={label}
      value={value}
      onChange={e => onChange(e.target.value as Mode)}>
      <MenuItem value="url">{urlLabel}</MenuItem>
      <MenuItem value="text">{textLabel}</MenuItem>
    </Select>
  </FormControl>
);

const ToneSelect: React.FC<{
  label: string;
  value: Tone;
  onChange: React.Dispatch<React.SetStateAction<Tone>>;
  labels: {
    friendly: string;
    professional: string;
    witty: string;
    formal: string;
  };
}> = ({ label, value, onChange, labels }) => (
  <FormControl size="small" fullWidth>
    <InputLabel>{label}</InputLabel>
    <Select
      label={label}
      value={value}
      onChange={e => onChange(e.target.value as Tone)}>
      <MenuItem value="friendly">{labels.friendly}</MenuItem>
      <MenuItem value="professional">{labels.professional}</MenuItem>
      <MenuItem value="witty">{labels.witty}</MenuItem>
      <MenuItem value="formal">{labels.formal}</MenuItem>
    </Select>
  </FormControl>
);

const MediaSelect: React.FC<{
  label: string;
  value: MediaSource;
  onChange: React.Dispatch<React.SetStateAction<MediaSource>>;
  labels: { none: string; ai: string; upload: string; url: string };
}> = ({ label, value, onChange, labels }) => (
  <FormControl size="small" fullWidth>
    <InputLabel>{label}</InputLabel>
    <Select
      label={label}
      value={value}
      onChange={e => onChange(e.target.value as MediaSource)}>
      <MenuItem value="none">{labels.none}</MenuItem>
      <MenuItem value="ai">{labels.ai}</MenuItem>
      <MenuItem value="upload">{labels.upload}</MenuItem>
      <MenuItem value="url">{labels.url}</MenuItem>
    </Select>
  </FormControl>
);

export { PlatformSelect, ModeSelect, ToneSelect, MediaSelect };
